import React from 'react';
import { FaRocket, FaAmazon, FaChartLine, FaRobot } from 'react-icons/fa';

const Step1Welcome = ({ user, onNext }) => {
  const features = [
    {
      icon: <FaAmazon className="text-4xl text-orange-500" />,
      title: 'Amazon Integration',
      description: 'Connect your Amazon Seller account and sync products & orders automatically'
    },
    {
      icon: <FaChartLine className="text-4xl text-green-500" />,
      title: 'Real-time Analytics',
      description: 'Track sales, profits, and performance with beautiful dashboards'
    },
    {
      icon: <FaRobot className="text-4xl text-blue-500" />,
      title: 'AI-Powered Tools',
      description: 'Smart pricing calculator and AI chat assistant to help grow your business'
    }
  ];

  const planFeatures = user?.subscription?.plan === 'pro' ? [
    'Unlimited products',
    'Profit Tracker',
    'Predictive Alerts',
    'Money Recovery',
    'Amazon Ads Management',
    'Unlimited AI Chat'
  ] : [
    'Up to 100 products',
    'Basic Dashboard',
    'AI Calculator',
    '100 AI Chat messages/month',
    'Order history (90 days)'
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-8">
      {/* Welcome Message */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full mb-4">
          <FaRocket className="text-3xl text-white" />
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Welcome, {user?.name}!
        </h2>
        <p className="text-lg text-gray-600">
          You're on the <span className="font-semibold text-indigo-600 capitalize">{user?.subscription?.plan}</span> plan
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid md:grid-cols-3 gap-6 mb-8">
        {features.map((feature, index) => (
          <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
            <div className="flex justify-center mb-4">
              {feature.icon}
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {feature.title}
            </h3>
            <p className="text-sm text-gray-600">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* Plan Features */}
      <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-lg p-6 mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Your Plan Includes:
        </h3>
        <div className="grid md:grid-cols-2 gap-3">
          {planFeatures.map((feature, index) => (
            <div key={index} className="flex items-center">
              <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
      </div>

      {/* What's Next */}
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
        <h4 className="text-lg font-semibold text-blue-900 mb-2">
          What's Next?
        </h4>
        <p className="text-blue-800">
          We'll guide you through connecting your Amazon account, importing your data, 
          and exploring the platform. This should take about 5-10 minutes.
        </p>
      </div>

      {/* Action Button */}
      <div className="text-center">
        <button
          onClick={() => onNext()}
          className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl"
        >
          Let's Get Started →
        </button>
      </div>
    </div>
  );
};

export default Step1Welcome;
